import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './LogoGallery.css'; // Optional for external styling

const imageFilenames = [
    "progressive.png", "WestPACInsurance.png", "Safeco3.webp", "Travelers.png",  "AHSLogo.jpg",
    
     "the-hartford-logo-png-transparent.png", "Nationwide_Mutual_Insurance_Company_logo.svg.png","pinnacle-risk-solutions-logo.jpg",
    
  "AMWins.png",
  "BondExchange_Logo.jpg", "BristolWestInsurnace.png", "BurnsWilcox.png",  "CapitalInsurnaceGroup.png","Geico.png",
  "CapitalPremium Financing.jpg", "chubb.png", "CNA-Surety-Stacked-JPG.jpg",
  "Colonial-General-Logo.png", "CRC_Group_logo_horizontal_red.png", "Distinguished_programs_logo_2020_Logo.jpg",
   "foremost-insurance-logo.jpg", "Hagerty-logo-car-love.png",
  "HiscoxLogo.png", "Kemper_Logo_Color_Web.jpg", "Liberty-Mutual-Logo.png", "MarkelInsurnce.png",
  "MarketScout.jpg", "MendotaInsurnace.jpg", "met-life-des-foundations-standards-logo-asset-01.png",
  "NationalGeneral.png", 
  "next-logo-large_new.png", "personalumbrella-logo-color-notag.png", "philadephia-this-one.jpg",
   "pinnacol-assurance-vector-logo.png", "RIC Insurnace.png",
  "risk-placement-services-logo.png", 
  "The_General_Logo.jpg", "usli.png", "VirtusInsurance.png", 
];

const InsuranceCarriersList_v01 = () => {

  return (
    <Container>
      <h2 className="text-center mb-4">Insurance Carriers</h2>
      <h4 className="text-center mb-4">We shop the insurance companies for you to find the best coverage and pricing to match your unique requirements.</h4>
      
      <hr></hr>

      <Row xs={1} sm={2} md={3} lg={4} className="g-4">
        {imageFilenames.map((file, index) => (
          <Col key={index} className="logo-card">
            <img 
              src={`./insurance/images/carrierLogos/${file}`}
              alt={file.replace(/\.[^/.]+$/, '')}
              className="logo-img img-fluid carrierLogoSize"
            />
          </Col>
        ))}
      </Row>

    </Container>

  );
};

export default InsuranceCarriersList_v01;
